import HttpService from "@/modules/core/network/http-service";

class EquipmentInventoryService extends HttpService {
  constructor() {
    super("stock/equipment-inventory");
  }
}

export default new EquipmentInventoryService();
